import { CUSTOMER_BUSINESS_NATURES } from "../../../common/enums/businessNatures";
import type { WhosNewReportRecord } from "../../../services/ActionReports/ActionReportAPI.types";

export const isWhosNewCustomerRecord = (record: Pick<WhosNewReportRecord, "BusinessNature">): boolean =>
  CUSTOMER_BUSINESS_NATURES.has(Number(record.BusinessNature));

type WhosNewDisplayNameOptions = {
  confidentialUser: string;
  newCustomerLabel: string;
  showCustomerDetails: boolean;
};

export const getWhosNewDisplayName = (
  record: Pick<WhosNewReportRecord, "BusinessNature" | "ConfidentialUser" | "Level" | "Name">,
  { confidentialUser, newCustomerLabel, showCustomerDetails }: WhosNewDisplayNameOptions,
): string => {
  if (record.ConfidentialUser) {
    return confidentialUser;
  }

  if (isWhosNewCustomerRecord(record) && record.Level > 2 && !showCustomerDetails) {
    return newCustomerLabel;
  }

  return record.Name;
};
